import { render, staticRenderFns } from "./site-notification.vue?vue&type=template&id=768b69fd&"
import script from "./site-notification.vue?vue&type=script&lang=js&"
export * from "./site-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports